// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";
import PayPalHeader from "./header";

function PayPal() {
  const title = "PayPal";
  usePageTitle(title);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PayPalHeader />
      <Footer />
    </DashboardLayout>
  );
}

export default PayPal;
